<template>
<m-pageframe
    title="My App Installs"
>
<v-container
    fluid
>
    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>
    
            <v-list>
                <v-list-item
                    v-on:click="onClickDoSomething()"
                >
                    <v-list-item-title>Do Something...</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu> 
    </v-text-field>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
        <template v-slot:item.organization_id="{ item }">
            <v-icon
                size="16"
                style="position: relative; top: -2px"
                v-on:click.stop="$rc.copy(item.organization_id);"
            >
                mdi-content-copy
            </v-icon>

            <span style="font-family: monospace">
            {{item.organization_id}}
            </span>
        </template>
    
    </v-data-table>

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {
    data() {
        return {
            results: [],
            full_text: null,
            headers: [
                { text: 'Organization Id', value: 'organization_id'},
                { text: 'Organization Label', value: 'organization_label'},
                { text: 'App Label', value: 'app_label'},
                { text: 'Version', value: 'version'},
            ],
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/apps/my-apps/installs',
            
                'params' : {
                        'app_id': this.$route.params.app_id,
                        'full_text': this.full_text,
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                    },
            
                'on_error': 'Unable to search app installs',
            });
        },
        
    },
}
</script>

<style lang="scss" scoped>
</style>